module.exports = __webpack_public_path__ + "static/09-c2e310184df1f3690df7f0f595f516f7.png";